/**
 * BoxWithBackground component
 * @returns <BoxWithBackground />
 */

import BoxWithBackgroundCard from "./BoxWithBackgroundCard";
import Button from "./Button";

const BoxWithBackgroundContainer = (props) => {
    const { image, items, extraClass, titleAndButton } = props;

    if (extraClass === "--store-version") {
        return (
            <div className={`box-with-background__store-version`}>
                <div className="box-with-background_container box-flex-store">
                    {items.map((item, i) => {
                        return (
                            <div className="content" key={i}>
                                <BoxWithBackgroundCard item={item} />
                            </div>
                        );
                    })}
                </div>

                {/* <div className="paginator">
                    <p>Paginador</p>
                </div> */}
            </div>
        );
    } else {
        return (
            <div
                className={`box-with-background ${
                    extraClass ? extraClass : ""
                }`}
            >
                {image && (
                    <img
                        src={image}
                        alt=""
                        className="box-with-background_img"
                    />
                )}

                <div className="wrapper">
                    {
                        titleAndButton && (
                            <p className="box-with-background_title">Mantenciones destacadas</p>
                        )
                    }
                    <div className="box-with-background_container box-flex-store">
                        {items.map((item, i) => {
                            return (
                                <div className="content store-width" key={i}>
                                    <BoxWithBackgroundCard
                                        item={item}
                                        background={""}
                                    />
                                </div>
                            );
                        })}
                    </div>
                    {
                        titleAndButton && (
                            <Button
                                text="Ver todas las mantenciones"
                                tag="button-link"
                                url="/mantenciones"
                                btnStyle="outline"
                                extraClass="box-with-background_button"
                            />
                        )
                    }
                </div>
            </div>
        );
    }
};

export default BoxWithBackgroundContainer;
